import { Autocomplete } from '@mui/material';
import styled from 'styled-components';

export const ContainerAutocomplete = styled(Autocomplete)`

`;
